module.exports = __webpack_public_path__ + "img/list-music.3971c78b.svg";